export const MessageTypes = {
  MESSAGE_CREATED: 'messaging.MessageCreated',
};



// WEBPACK FOOTER //
// ./src/modules/messaging/constants/index.js